<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :fabricationActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "Fabrication",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "fabrication/IMG_20170313_093320.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "fabrication/IMG_20170313_093417.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "fabrication/IMG-20171103-WA0003.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "fabrication/IMG-20180322-WA0003.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "fabrication/IMG-20171209-WA0006.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Fabrication",
    serviceDescription:
      "Aluminium fabrication & installation services with glass Railing Flooring Canopy Frameless Shower Enclosure Sliding Stacking Doo"
  })
};
</script>
